import * as React from 'react';

import { useEnterpriseProgramsByOrganizationSlug } from 'bundles/enterprise-admin-hooks/hooks/useEnterpriseProgramsByOrganizationSlug';
import { useSystemProgram } from 'bundles/enterprise-admin-hooks/hooks/useSystemProgram';
import { useEnterpriseAdminPermissions } from 'bundles/enterprise-admin-roles/components/EnterprisePermissionsProvider';
import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';

/**
 * Groups (programs) the current admin can manage learners in — shared by the "Add to
 * group" and "Assign content" group pickers on the Group Details and All Learners
 * bulk-action bars. Excludes the org's hidden system program ("All learners") — it is
 * never a real, admin-manageable group.
 */
export const useManageableGroups = () => {
  const org = useThirdPartyOrganization();
  const { hasPermission } = useEnterpriseAdminPermissions();
  const { programs } = useEnterpriseProgramsByOrganizationSlug(org.slug, 'LEARNERS');
  const { systemProgram } = useSystemProgram(org.id);

  return React.useMemo(
    () =>
      (programs ?? []).filter(
        (program) =>
          program.id !== systemProgram?.id &&
          hasPermission({ domain: 'PROGRAM', domainId: program.id, verb: 'MANAGE', subdomain: 'LEARNERS' })
      ),
    [programs, systemProgram, hasPermission]
  );
};
